<template>
  <Layout>
  <div class="home-page-80-width">
    <h1 class="font-size-24 pt-5 text-center text-uppercase  font-weight-bold text-dark" style="font-size: 1.8rem !important;"><span class="d-none d-lg-inline">Le concept des </span>sacs Personnalisés</h1>
    <h2 class="text-left process-heading mt-5 pt-4 mb-0 pb-0" style="font-size:1.5rem;">Votre emballage personnalisé en 6 étapes !</h2>
    
    <!-- Aperçu des Étapes -->
    <div class="row step-overview mb-0">
      <div v-for="(step, index) in steps" :key="index" class="col-md-2 col-sm-6 p-2 p-lg-0 pr-0 pr-lg-5 mt-4 mb-0 ">
        <div 
          class="card step-card"
          :class="{ 'active': currentStep === index }"
          role="button"
          tabindex="0"
          @click="goToStep(index)"
        >
          <div class="card-body text-center">
            <div class="step-number">{{ index + 1 }}</div>
            <img :alt="step.imageAlt" :width="step.imageWidth" :src="require(`@/assets/icons/${step.image}`)"/>
            <h5 class="card-title text-primary mb-4" :class="index == 2 ? 'mt-0' : 'mt-3'">{{ step.title }}</h5>
            <p class="card-text d-none d-xl-block font-size-14 font-weight-bold">{{ step.description }}</p>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Barre de Progression -->
    <div class="progress-bar-container d-none ">
      <div class="custom-progress">
        <div 
          class="custom-progress-bar" 
          :style="{ width: progressPercentage + '%' }"
        ></div>
        
        <div 
          v-for="step in steps.length" 
          :key="step"
          class="step-dot"
          :class="{
            'active': currentStep === step - 1,
            'completed': currentStep > step - 1
          }"
          :style="{ left: calculateDotPosition(step) + '%' }"
          @click="goToStep(step - 1)"
        >
          <!-- <span class="step-label">Étape {{ step }}</span> -->
        </div>
      </div>
    </div>
  
    <!-- Contenu des Étapes -->
    <div class="process-content pt-4 mb-5">
      <div 
        v-for="(step, index) in steps"
        :key="index"
        class=" process-step p-sm-3 pt-5"
        :class="{ 'active': currentStep === index }"
      >
        <div class="-body">
          <div class="row">
            <!-- <div class="col-md-4 mb-4 mb-md-0">
              <div class="text-center">
                <i :class="step.icon + ' step-icon'"></i>
                <h3 class="mb-3">{{ step.title }}</h3>
              </div>
              
              <div class="img-placeholder rounded  d-flex align-items-center justify-content-center" style="height: 200px;">
                <span class="text-muted">
                  <img 
                    :alt="step.imageAlt" 
                    class="mb-2  image-step" 
                    v-if="step.image" 
                    height="200"
                    :src="require('@/assets/images/' + step.image )">

                  
                </span>
              </div>
            </div> -->
            
            <div class="col-md-12">

              <div class="text-left">
                <h3 class="mb-3 text-primary">{{ step.title }}</h3>
              </div>

              <!-- <h4>Détails</h4> -->
              <p class="font-size-18 text-justify text-dark">{{ step.details }}</p>
              
              <!-- <h5 class="mt-4">Caractéristiques Principales</h5> -->
              <ul class="feature-list pt-3">
                <li v-for="(feature, featureIndex) in step.features" :key="featureIndex" class="font-size-16">
                  <img  alt="" width="19px"
                    style="cursor: pointer;" 
                    src="@/assets/icons/check-circle-fill.svg"
                    class="pb-1"/>
                  {{ feature }}
                </li>
              </ul>
              
              <div class="mt-4 p-3 rounded" style="background-color: var(--gray-color);">
                <p class="mb-0">
                  <img  alt="" width="14px"
                    style="cursor: pointer;" 
                    src="@/assets/icons/lightbulb.svg"
                    class="pb-1"/>
                    {{ step.tip }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    

  <div class="mt-5 mb-5 d-none">
    <h1 class="font-size-24 pt-5 text-center text-uppercase  font-weight-bold text-dark" style="font-size: 2.3rem !important;">Les objectifs et les avantages</h1>
    <h2 class="font-size-22 mb-5 process-heading  text-center">Leader industriel dans la création de sacs personnalisés de qualité</h2>

    <div class="pt-3 pb-5 card card-body">
      <div class="home-page-60-width row pt-md-4 pt-1 text-center justify-content-center">
        <div
          v-for="(feature) in mediaFeatures"
          :key="feature.id"
          class="col-sm-3 col-12 col-xl-3 mb-sm-4 mt-sm-4 pr-sm-4 pl-sm-4 card mediaFeatures-card d-flex flex-column align-items-self-end"
        >
          <div class=" h-100 w-100 d-flex flex-column">
            <h4 class="mt-2 mb-3 font-weight-bold text-primary text-uppercase mediaFeatures-title">
              {{ $t(feature.title) }}
            </h4>
            <p class="mt-2 text-dark font-size-14 text-justify mediaFeatures-card-description" style="margin-bottom: 0; flex-grow: 1;">
              {{ $t(feature.description) }}
            </p>
            <div class=" mt-3 text-center">
              <a class="pr-3" :href="feature.href">
                <b-button variant="primary" style="letter-spacing: 2px;" class="font-weight-bold text-uppercase mediaFeatures-button font-size-14 p-3 w-100">
                  {{ $t(feature.button) }}
                </b-button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</Layout>
</template>

  
<script>
import Layout from "../../layouts/main";

  export default {
    components: {
      Layout,
    },
    data() {
      return {
        currentStep: 0,
        mediaFeatures: [
        {
            id: '1',
            title: 'personnalisation des Sacs',
            description:'Créez facilement vos designs, des sacs uniques en personnalisant chaque détail: couleurs, Types, motifs et logos. Notre outil de conception intuitif vous permet de visualiser votre modèle avant la commande.',
            button:'Personnaliser vos Sacs',
            href:"/demarrer-experience"
        },
        {
            id: '2',
            title: 'Commandes en Petites Quantités',
            description:'Que vous ayez besoin de quelques sacs ou d’une petite série, nous produisons avec soin, efficacité et une attention particulière pour répondre parfaitement à vos attentes, sans exiger de commande en gros.',
            button:'Consulter nos produits',
            href:"/sac-personnalise"
        },
        {
            id: '3',
            title: 'Commande et Paiement Séecurisé',
            description:'Bénéficiez d’une expérience d’achat fluide. Passez vos commandes en ligne en toute simplicité et effectuez vos paiements avec une confiance absolue grâce à nos systèmes de  paiement  fiables et  sécurisés.',
            button:'Payer vos commandes',
            href:"/paiement"
        }
      ],

        steps: [
          {
            title: 'UNIVERS DES SACS',
            description: 'Choisissez l\'nivers de sac qui correspond à votre activité',
            details: 'Nous proposons des univers telles que Pâtisserie, Fast Food, Parapharmacie, Opticien, etc. La sélection d’une univers ouvrira les modèles adaptés à vos besoins spécifiques.',
            image: 'list.svg',
            imageWidth : "50px",
            imageAlt: 'Icônes de différentes univers',
            features: [
              'Pâtisserie',
              'Restaurant et Fast Food',
              'Parapharmacie et Opticien'
            ],
            tip: 'Choisissez l\'univers qui correspond le mieux à votre activité pour accéder aux modèles les plus adaptés.'
          },
          {
            title: 'CHOISIR UN MODÈLE',
            description: 'Choisissez le modèle qui correspond à vos besoins',
            details: 'Chaque univers propose des modèles dédiés. Par exemple, pour Restaurants et Fast Food, nous proposons des sacs écologiques respectant les normes alimentaires.',
            image: 'box.svg',
            imageWidth : "50px",
            imageAlt: 'Modèles de sacs par univers',
            features: [
              'Modèles écologiques pour la restauration',
              'Sacs spécialisés pour pharmacie et optique',
              'Adaptés aux besoins spécifiques de chaque secteur'
            ],
            tip: 'Pensez à choisir un modèle qui valorise vos produits tout en étant pratique pour vos clients.'
          },
          {
            title: 'CHOISIR UN TYPE DE SAC',
            description: 'Choisissez les dimensions, types et tailles de vos sacs',
            details: 'Nous proposons différentes tailles et types de sacs: Par exemple, pour Restaurants et Fast Food, sacs pour sandwichs longs, sacs pour frites, sacs standards, etc.',
            image: 'box-open.svg',
            imageWidth : "70px",
            imageAlt: 'Différentes tailles et types de sacs',
            features: [
              'Variété de tailles du petit au grand',
              'Types spécifiques selon les produits (sandwichs, pâtisseries...)',
              'Options standards et sur mesure'
            ],
            tip: 'Sélectionnez plusieurs types si vos produits varient en dimensions.'
          },
          {
            title: 'CHOISIR UN TYPE DE PAPIER',
            description: 'Choisissez le type du papier : kraft ou ingraissable',
            details: 'La qualité du papier influence l’apparence et la robustesse de vos sacs. Nous proposons du papier kraft et ingraissable.',
            image: 'leaf.svg',
            imageWidth : "50px",
            imageAlt: 'Échantillons de matériaux en papier',
            features: [
              'Papier kraft',
              'Papier ingraissable'
            ],
            tip: 'Pour un rendu naturel et écologique, privilégiez le kraft brun.'
          },
          {
            title: 'CHOISIR UNE COULEUR DU PAPIER',
            description: 'Sélectionnez la couleur souhaitée pour votre sac : brun ou blanc.',
            details: 'Le choix de la couleur varie selon l’univers, le type de sac et le design. Veuillez sélectionner la combinaison qui correspond le mieux à vos préférences.',
            image: 'print.svg',
            imageWidth: "50px",
            imageAlt: 'Échantillons de couleurs de papier',
            features: [
              'Papier kraft - couleur brun',
              'Papier kraft - couleur blanc',
              'Papier ingraissable - couleur brun',
              'Papier ingraissable - couleur blanc'
            ],
            tip: 'NB : Les couleurs peuvent légèrement différer de celles affichées à l’écran en raison du processus d’impression.'
          },
          {
            title: 'PERSONNALISER ET PRÉVISUALISER ',
            description: 'Ajouter avec vos informations, prévisualiser et valider la commande',
            details: 'Nous réalisons une impression de haute qualité avec vos éléments personnalisés. Ajoutez titres, logos, coordonnées, QR codes, et plus. Avant validation, visualisez l’aperçu du modèle, rectifiez les données saisies et ajustez la taille ou l’emplacement du logo si nécessaire.',
            image: 'clipboard-check.svg',
            imageWidth : "50px",
            imageAlt: 'Personnalisation et aperçu du sac',
            features: [
              'Ajout de logo, titre, adresse, téléphone',
              'Ajout d’éléments interactifs comme QR codes',
              'Aperçu visuel complet avant validation',
              'Correction possible des éléments personnalisés',
            ],
            tip: 'Assurez-vous que votre logo est en haute résolution et vérifiez tous les détails avant de valider pour garantir une impression optimale.'
          }
        ]


        
      };
    },
    computed: {
      progressPercentage() {
        return (this.currentStep / (this.steps.length - 1)) * 100;
      }
    },
    methods: {
    
     
      goToStep(stepIndex) {
        this.currentStep = stepIndex;
         this.scrollToTop();
      },
     
      scrollToTop() {
        if (window.innerWidth < 768) {
          const element = document.querySelector('.process-content');
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            
          }
        }
      },
      calculateDotPosition(step) {
        return ((step - 1) / (this.steps.length - 1)) * 100;
      },

    }
  };
</script>
<style>
  :root {
    --primary-color: #2445be;
    --secondary-color: #2e46a3;
    --accent-color: #1d3caa;
    --light-color: #f9f9f9;
    --dark-color: #333333;
    --gray-color: #e9ecef;
    --transition-speed: 0.3s;
  }
  
  body {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    background-color: var(--light-color);
    color: var(--dark-color);
  }
  
  .card {
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: transform var(--transition-speed);
  }
  
  .step-card:hover {
    transform: translateY(-5px);
  }
  
  .mediaFeatures-card{
    box-shadow: 0 0px 0px;

    height: 100%;
    border: none;
    background-color: white;
    position: relative;
    overflow: hidden;
    padding : 2rem ;
  }
  .mediaFeatures-title{
    height: 40px !important;
  }
  @media (min-width: 1300px) {
    .mediaFeatures-title{
      height: 25px !important;
    }
  }
  @media (min-width: 576px) and (max-width: 767px) {
    .mediaFeatures-title{
      height: 55px !important;
    }
  }


  @media (min-width: 576px) and (max-width: 1050px) {
    .mediaFeatures-button{
      height: 73px  !important;
    }
  }


  @media (min-width: 1200px) {
    .mediaFeatures-card-description {
      height: 120px; 
    }
  }
  @media (max-width: 1200px) {
    .mediaFeatures-card-description {
      height: 160px; 
    }
  }
  @media (max-width: 767px) {
    .mediaFeatures-card-description {
      height: 180px; 
    }
  }

  @media (max-width: 576px) {
    .mediaFeatures-card-description {
      height: 140px; 
    }
  }

  
  .step-card {
    height: 100%;
    border: none;
    background-color: white;
    position: relative;
    overflow: hidden;
    cursor: pointer;
  }
  
  .step-card.active {
    border: 2px solid var(--primary-color);
  }
  
  .step-number {
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: var(--primary-color);
    color: white;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
  }
  
  .step-icon {
    font-size: 3rem;
    color: var(--primary-color);
    margin-bottom: 1rem;
  }
  
  .process-heading {
    color: var(--primary-color);
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  
  .progress-bar-container {
    margin: 2rem  2rem ;
    margin-bottom: 3rem;

  }
  
  .custom-progress {
    height: 10px;
    background-color: var(--gray-color);
    border-radius: 5px;
    position: relative;
  }
  
  .custom-progress-bar {
    height: 100%;
    background-color: var(--primary-color);
    border-radius: 5px;
    transition: width var(--transition-speed);
  }
  
  .step-dot {
    width: 20px;
    height: 20px;
    background-color: var(--gray-color);
    border-radius: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    transition: background-color var(--transition-speed);
    cursor: pointer;
  }
  
  .step-dot.active {
    background-color: var(--primary-color);
  }
  
  .step-dot.completed {
    background-color: var(--secondary-color);
  }
  
  .step-label {
    position: absolute;
    top: 30px;
    transform: translateX(-50%);
    font-size: 1rem;
    white-space: nowrap;
    color: var(--dark-color);
  }
  
  .process-step {
    margin-top: 2rem;
    display: none;
  }
  
  .process-step.active {
    display: block;
    animation: fadeIn 0.5s;
  }
  
  .navigation-buttons {
    margin-top: 2rem;
    display: flex;
    justify-content: space-between;
  }
  
  .btn-primary {
    background-color: var(--primary-color);
    border-color: var(--primary-color);
  }
  
  .btn-primary:hover {
    background-color: var(--secondary-color);
    border-color: var(--secondary-color);
  }
  
  .btn-outline-primary {
    color: var(--primary-color);
    border-color: var(--primary-color);
  }
  
  .btn-outline-primary:hover {
    background-color: var(--primary-color);
    color: white;
  }
  

  
  .feature-list {
    list-style-type: none;
    padding-left: 0;
  }
  
  .feature-list li {
    margin-bottom: 0.5rem;
  }
  
  @media (max-width: 768px) {
    .step-overview {
      margin-bottom: 2rem;
    }
    
    .step-card {
      margin-bottom: 1rem;
    }
    
    .step-label {
      font-size: 0.7rem;
    }
  }
  
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
</style>